import { Component, OnInit, Input, SimpleChanges } from '@angular/core';
import { CommerceDataService } from '../../../services/commerce-data.service';


@Component({
  selector: 'app-order-summary-sidebar',
  templateUrl: './order-summary-sidebar.component.html',
  styleUrls: ['./order-summary-sidebar.component.css']
})
export class OrderSummarySidebarComponent implements OnInit {

  @Input() shippingCost;

  cartTotalBreakDown
  cartItemsSubscription;
  shoppingCartEmpty

  constructor( private _ecomm: CommerceDataService) { }

  ngOnInit() {
    this.cartTotalBreakDown = this._ecomm.calculateCartTotal()
    this.cartTotalBreakDown['shipping'] = this.shippingCost
    this.cartTotalBreakDown['totalInclusive'] += this.shippingCost
    //Subscribe to the cart items changes and update this cart items every time there is new updates
    this.cartItemsSubscription = this._ecomm.cartItemsChanged.subscribe(
      (data) => {
        this.cartTotalBreakDown = this._ecomm.calculateCartTotal()
        this.cartTotalBreakDown['shipping'] = this.shippingCost
        this.cartTotalBreakDown['totalInclusive'] += this.shippingCost
      }
    );
  }

  ngOnChanges(changes: SimpleChanges) {
    // only run when property "data" changed

    if (changes['shippingCost']) {
      this.cartTotalBreakDown = this._ecomm.calculateCartTotal()
      this.shippingCost = changes['shippingCost'].currentValue;
      this.cartTotalBreakDown['shipping'] = this.shippingCost
      this.cartTotalBreakDown['totalInclusive'] += this.shippingCost
    }
   
  }

}
